import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  showWarningAlert(
    title: string,
    message: string,
    duration: number = 5000,
  ): void {
    const alertElement = document.createElement('div');
    alertElement.innerHTML = `
    <div style="
      position: fixed;
      top: 20px;
      right: 20px;
      background: #FFF2E5;
      border: 1px solid #FFF2E5;
      border-radius: 6px;
      padding: 10px 10px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 10000;
      max-width: 300px;
      font-family: Arial, sans-serif;
      border-left: 5px solid #D5710C;
    ">
      <div style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="color: #D5710C; font-size: 20px;">⚠️</span>
        <div>
          <div style="font-weight: 500;font-size: 12px; margin-bottom: 4px;color: #1A1A1A;">
            ${title}
          </div>
          <div style="font-size: 12px;font-weight: 500; color: #1A1A1A;">
            ${message}
          </div>
        </div>
        <button onclick="this.parentElement.parentElement.parentElement.remove()"
                style="background: none; border: none; font-size: 30px; cursor: pointer; color: #003F2D;">
          ×
        </button>
      </div>
    </div>
  `;

    document.body.appendChild(alertElement);
    setTimeout(() => {
      if (alertElement.parentNode) {
        alertElement.parentNode.removeChild(alertElement);
      }
    }, duration);
  }
}
